export default __webpack_public_path__ + "static/featuresListItem10-2a88d7844c05f9109043f965e27dcb2d.svg";